import { PayloadAction } from '@reduxjs/toolkit';

import { getLineItem } from '../../logic/line-item';
import { WritableAutoConfiguratorState } from '../slice';

type Payload = {
  lineItemUuid: string;
  attachmentId: string;
};

export function removeLineItemAttachment(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<Payload>,
) {
  const { lineItemUuid, attachmentId } = action.payload;

  const lineItem = getLineItem(state, lineItemUuid);

  lineItem.attachments = lineItem.attachments.filter(
    (attachment) => attachment.id !== attachmentId,
  );
}
